import { cmsDisruptionBannerRemove } from '@actions/cms.action';
import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { DisruptionBanner } from '@models/cms/disruption-banner.model';
import { Store } from '@ngrx/store';
import {
  SafeHtmlPipe,
  SanitizerValueType,
} from '@pipes/safe-html/safe-html.pipe';
import { fadeIn } from 'src/app/animations/fade.animation';

@Component({
  selector: 'app-disruption-banner',
  standalone: true,
  imports: [CommonModule, RouterModule, SafeHtmlPipe, SvgIconComponent],
  templateUrl: './disruption-banner.component.html',
  styleUrls: ['./disruption-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeIn],
})
export class DisruptionBannerComponent {
  @Input() banner: DisruptionBanner | null = null;

  readonly SanitizerValueType = SanitizerValueType;

  constructor(private store: Store) {}

  removeNotification(id: string): void {
    this.store.dispatch(cmsDisruptionBannerRemove({ id }));
  }
}
